<template lang="pug">
  div
    app-modal-visualizar-completo(
      v-if="showModalVisualizarProcesso && idProcesso !== null",
      @closeModal="showModalVisualizarProcesso = false",
      :idProcesso="idProcesso",
      :protocolo="protocolo",
      :numeroProcesso="numeroProcesso",
      :tipo="tipoProcesso"
    )
    modal-suspensao-processo(
      v-if="showModalSuspensaoProcesso",
      @closeModal="showModalSuspensaoProcesso = false",
      @refresh='refresh',
      :idProcesso="idProcesso",
      :numeroProcesso="numeroProcesso",
      :caixaSuspensao="true",
      :setor="setor",
      :sIndireta="sIndireta"
      :isCancelamento="isCancelamento"
    )
    el-card.card-container(shadow="hover")
      filtro(
        @pesquisar="pesquisar",
        @limpar="clear",
        :showOs="true",
        :showMunicipios="true",
        :configuracaoFiltro="configuracaoFiltro",
        :filtroRapido="filtroRapido",
        :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
      )
    app-listagem(
      :has-refresh-button="true",
      :showButtonOrdemServico="false",
      :showButtonAssinatura="false",
      :has-expansivel="false",
      :json-headers="colunas",
      :json-data="items",
      :totalElements="totalElements",
      :pagina="filtro.pagina",
      :hasFiltroRapido="true",
      :filtro="filtro",
      @atualizarFiltro="atualizarFiltro",
      @updateListagem="refresh",
      @changePage="changePage",
      @sort="sort",
      @executar="executar",
      @selected="false"
    )
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppListagem from '@/components/AppListagem'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import ModalSuspensaoProcesso from '@/components/ModalSuspensaoProcesso.vue'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'

const { filtro, showFiltroTipoMultiplo, suspensaoIndireta } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {
  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    ModalSuspensaoProcesso
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('VIEW_PROCESSOS_SUSPENSOS'),
      idProcesso: null,
      processo: {},
      showModalVisualizarProcesso: false,
      items: [],
      protocolo: '',
      tipoProcesso: '',
      totalElements: 0,
      setorSelecionado: null,
      dados: {
        idProcesso: null,
        setorAnteriorSuspensao: null,
        statusSuspensao: null
      },
      numeroProcesso: '',
      exibeAcaoSuspender: false,
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroResponsavel?.VIEW_PROCESSOS_SUSPENSOS || []
      },
      situacoes: [
        { codigo: 'AGUARDANDO_SUSPENSAO', nome: 'Aguardando Suspensão' },
        { codigo: 'SUSPENSO', nome: 'Suspenso' }
      ],
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 5, titulo: 'Situação', propriedade: 'status', ordem: 6, acoes: [] },
        {
          id: 6,
          titulo: 'Ações',
          propriedade: 'tipo',
          ordem: 7,
          acoes: [
            {id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso},
            {id: 2, nome: 'Cancelar Suspensão', icone: 'fa-ban', codigo: 'CANCELAR_SUSPENSAO', ordem: 2, show: this.showAcaoCancelarSuspensao},
            {id: 3, nome: 'Suspender', icone: 'fa-pause-circle', codigo: 'SUSPENDER', ordem: 3, show: this.showAcaoSuspender}
          ]
        }
      ],
      showFiltroTipoMultiplo,
      filtroRapido: null,
      setor: null,
      tarefa: null,
      setoresFluxo: [],
      showModalSuspensaoProcesso: false,
      sIndireta: false,
      perfilSelecionado: null,
      isCancelamento: false
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    })
  },

  created () {
    this.perfilSelecionado = this.usuarioLogado.perfilSelecionado.nome
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario',
      fecharPendencia: 'conversa/fecharPendencia',
      suspender: 'despacho/criarDespachoSuspensaoProcesso',
      cancelar: 'processos/cancelarSuspensao'
    }),

    VISUALIZAR_PROCESSO (_this, { item }) {
      this.setDadosProcesso(item)
      this.showModalVisualizarProcesso = true
    },

    SUSPENDER (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.setor = item.setor
      this.sIndireta = suspensaoIndireta(this.perfilSelecionado)
      this.isCancelamento = false
      this.showModalSuspensaoProcesso = !this.showModalSuspensaoProcesso
    },

    CANCELAR_SUSPENSAO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.setor = item.setor
      this.sIndireta = false
      this.isCancelamento = true
      this.showModalSuspensaoProcesso = !this.showModalSuspensaoProcesso
    },

    setDadosProcesso (item) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.processo = item
      this.protocolo = item.numeroProtocolo
      this.tipoProcesso = item.tipoCodigo
    },

    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/analise/listagem/caixaSuspensao.vue